module.exports = __webpack_public_path__ + "img/cm-turneele-in-sua-2.e775d3bd.jpg";